import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CardDropdown from '@/components/common/CardDropdown';
import AdvanceTableWrapper from '@/components/common/advance-table/AdvanceTableWrapper';
import AdvanceTable from '@/components/common/advance-table/AdvanceTable';

const columns = [
  {
    accessor: 'title',
    Header: 'کلمه کلیدی',
    // headerProps: { className: 'pe-1 fw-medium text-900' },
  },
  {
    accessor: 'trainer',
    Header: 'رتبه',
    // headerProps: {
    //   className: 'pe-1 fw-medium text-900'
    // },
  },
  {
    accessor: 'published',
    Header: 'رتبه قبلی',
    // headerProps: {
    //   className: 'text-end fw-medium text-900'
    // },
    // cellProps: {
    //   className: 'text-end'
    // }
  },
  {
    accessor: 'enrolled',
    Header: 'تغییرات',
    // headerProps: {
    //   className: 'text-end fw-medium text-900'
    // },
    // cellProps: {
    //   className: 'text-end'
    // }
  },
];

const TopCoursesTable = ({ tableData }) => {
  const [data] = useState(tableData);
  return (
    <AdvanceTableWrapper
      columns={columns}
      data={data}
      sortable
      rowCount={data.length}
    >
      <AdvanceTable
        table
        headerClassName="bg-200"
        rowClassName="btn-reveal-trigger text-nowrap align-middle"
        tableProps={{
          className: 'fs--1 fw-semibold mb-0 overflow-hidden'
        }}
      />
    </AdvanceTableWrapper>
  );
};


export default TopCoursesTable;
